export default "__VITE_ASSET__CuwLtIzD__"